import React from 'react'
import LayoutTitle from 'teleporters/LayoutTitle'
import PageTitle from 'components/common/PageTitle'
import DailySnapshot from 'components/charts/DailySnapshot'
import EmployeeComfortLineChart from 'components/charts/EmployeeComfortLineChart'
import TestResults from 'components/charts/TestResults'
import SymptomsLastTwoWeeks from 'components/charts/SymptomsLastTwoWeeks'
import CustomQuestionsCharts from 'components/charts/CustomQuestionsCharts'

export const DashboardLegacyPage: React.FC = () => (
  <>
    <LayoutTitle.Source>
      <PageTitle>Dashboard</PageTitle>
    </LayoutTitle.Source>
    <DailySnapshot />
    <EmployeeComfortLineChart />
    <TestResults />
    <SymptomsLastTwoWeeks />
    <CustomQuestionsCharts />
  </>
)

export default DashboardLegacyPage
